export type SurveyMarginUpdateContext = {
  readonly isMarginOverrideEnabled: boolean;
  readonly isManualScpiOverrideEnabled: boolean;
  readonly isMarginMaxEnabled: boolean;
};

export class SurveyMarginUpdateInspector {
  public constructor(private readonly _context: SurveyMarginUpdateContext) {}

  public isUpdateAllowed(): boolean {
    const {
      isMarginOverrideEnabled,
      isManualScpiOverrideEnabled,
      isMarginMaxEnabled,
    } = this._context;
    const isInvalidForMarginUpdate =
      !isMarginOverrideEnabled ||
      (isManualScpiOverrideEnabled && isMarginOverrideEnabled) ||
      isMarginMaxEnabled;
    return !isInvalidForMarginUpdate;
  }

  public isValueEmpty(value: number | null | undefined): boolean {
    return value === null || value === undefined || value === 0;
  }
}
